import { defaultVisitors } from '@genericBookings/types/Visitors';
export default {
    ProductId: 217,
    ...defaultVisitors,
    acceptTerms: false,
};
